import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import posts from "./posts"; // Import posts
import "./BlogPostPage.css";

const BlogPostPage = () => {
  const { id, seoUrl } = useParams();  // Get both id and seoUrl from the URL
  const navigate = useNavigate();

  // Find the post by id
  const post = posts.find((p) => p.id === parseInt(id));

  if (!post) {
    return <div className="blog-post-page">הפוסט לא נמצא 😕</div>;
  }

  // Compare seoUrl from the URL with the seoUrl in the post object for SEO purpose
  if (post.seoUrl !== seoUrl) {
    // Redirect to the correct URL if the SEO URL doesn't match
    navigate(`/blog/${post.id}/${post.seoUrl}`, { replace: true });
  }

  return (
    <div className="blog-post-page">
      {/* 🔗 Breadcrumb */}
      <nav className="breadcrumb">
        <span onClick={() => navigate("/")}> דף הבית </span> &gt;
        <span onClick={() => navigate("/blog")}> בלוג </span> &gt;
        <span className="current"> {post.title} </span>
      </nav>

      <div className="post-content-wrapper">
        <h1>{post.title}</h1>
        <p className="post-meta">
          <span>{post.date}</span> | <span>{post.author} ✍🏻</span>
        </p>

        <p className="post-description">{post.description}</p>
        <div className="post-full-content" dangerouslySetInnerHTML={{ __html: post.content }} />

        <div className="post-tags">
          {post.tags.map((tag, index) => (
            <span key={index} className="tag">#{tag}</span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BlogPostPage;
